module.exports = __webpack_public_path__ + "img/597-42dfb3.png";